import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, mergeProps as _mergeProps, createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-d04da568"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "sales-report-new-table-config-options" };
const _hoisted_2 = { class: "sales-report-new-table-config-options__metrics-datepicker" };
const _hoisted_3 = { class: "sales-report-new-table-config-options__metrics-options" };
const _hoisted_4 = { class: "sales-report-new-config-options__btns-options config-options-header" };
const _hoisted_5 = { class: "export-wrapper" };
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("i", { class: "icon ml--4 icon-down-14px" }, null, -1));
import { ref, computed, onMounted } from 'vue';
import { useStore } from 'vuex';
import vSelect from 'vue-select';
// components
import HeaderDatepicker from '@/components/menu/_organisms/HeaderDatepicker.vue';
// services
import { fetchPresets, exportTable } from '@/features/SalesReportNew/data';
// utils
import { useMixpanelSelectAggregation } from '@/utilities/mixpanel';
export default /*#__PURE__*/ _defineComponent({
    __name: 'TableOptions',
    props: {
        hasExpandedTable: { type: Boolean }
    },
    setup(__props) {
        // libs
        // libs
        const store = useStore();
        const metricsOptions = ref([]);
        // computed
        const user = computed(() => store.getters['user']);
        const getPreset = computed(() => store.getters['salesReportNew/getPreset']);
        const getDefaultMetricsLength = computed(() => store.getters['salesReportNew/getDefaultMetricsLength']);
        const getSelectedMetricsAndDimensions = computed(() => store.getters['salesReportNew/getSelectedMetricsAndDimensions']);
        const getCampaignsId = computed(() => store.getters['salesReportNew/getCampaignsId']);
        const getSellersId = computed(() => store.getters['salesReportNew/getSellersId']);
        const getClusters = computed(() => store.getters['salesReportNew/getClusters']);
        const getStoresId = computed(() => store.getters['salesReportNew/getStoresId']);
        const getContactType = computed(() => store.getters['salesReportNew/getContactType']);
        const getOriginSale = computed(() => store.getters['salesReportNew/getOriginSale']);
        const getSelectedMetric = computed(() => store.getters['salesReportNew/getMetric']);
        const metric = computed({
            get() {
                return getSelectedMetric.value;
            },
            set(newValue) {
                return setMetric(newValue);
            },
        });
        // actions
        const setEditColumnsIsVisible = (isVisible) => store.dispatch('salesReportNew/setEditColumnsIsVisible', isVisible);
        const setIsTableExpanded = (isExpanded) => store.dispatch('salesReportNew/setIsTableExpanded', isExpanded);
        const setPreset = (preset) => store.dispatch('salesReportNew/setPreset', preset);
        const updateDefaultPreset = (preset) => store.dispatch('salesReportNew/updateDefaultPreset', preset);
        const setIsModalExportErrorVisible = (isVisible) => store.dispatch('salesReportNew/setIsModalExportErrorVisible', isVisible);
        const setBatchId = (batchId) => store.dispatch('salesReportNew/setBatchId', batchId);
        const setIsModalProgressVisible = (isVisible) => store.dispatch('salesReportNew/setIsModalProgressVisible', isVisible);
        const fetchExportJobDetails = () => store.dispatch('salesReportNew/setExportJobDetails');
        const fetchMetricsAndDimensions = (preset) => store.dispatch('salesReportNew/loadMetricsAndDimensions', preset);
        const fetchTable = () => store.dispatch('salesReportNew/setFetchTable');
        const setMetric = (metric) => store.dispatch('salesReportNew/setMetric', metric);
        const setKeyDimensionByPreset = () => store.dispatch('salesReportNew/setKeyDimensionsByPrest');
        const openEditTableModal = () => {
            fetchMetricsAndDimensions(metric.value.key);
            setEditColumnsIsVisible(true);
        };
        const fetchPrests = () => {
            fetchPresets().then((response) => {
                metricsOptions.value = response?.presets;
            });
        };
        const selectPreset = (preset) => {
            const key = preset.key;
            useMixpanelSelectAggregation('view_oto_sales_report_new_select-aggregation', key);
            setPreset(key);
        };
        const formatMetricsKeys = () => {
            const hasNonPreviewMetrics = getSelectedMetricsAndDimensions.value.some(metrics => metrics.preview !== 'true');
            const hasDefaultLength = getSelectedMetricsAndDimensions.value.length === getDefaultMetricsLength.value;
            if (!hasNonPreviewMetrics && hasDefaultLength) {
                return '';
            }
            const metricKeys = getSelectedMetricsAndDimensions.value.map(metrics => metrics.key).join(',');
            return metricKeys;
        };
        const exportSalesReportNew = (fileType) => {
            setIsModalExportErrorVisible(false);
            exportTable({
                fileType,
                metrics: formatMetricsKeys(),
                preset: getPreset.value,
                campaignId: getCampaignsId.value,
                storeId: getStoresId.value,
                sellerId: getSellersId.value,
                cluster: getClusters.value,
                originSale: getOriginSale.value,
                contactType: getContactType.value,
            })
                .then(response => {
                const batchId = response?.batchId;
                setBatchId(batchId);
                setIsModalProgressVisible(true);
            })
                .catch(() => {
                setIsModalExportErrorVisible(true);
            })
                .finally(() => {
                fetchExportJobDetails();
            });
        };
        onMounted(() => {
            updateDefaultPreset(metric.value.key);
            fetchPrests();
            fetchTable();
            setKeyDimensionByPreset();
        });
        return (_ctx, _cache) => {
            const _component_el_button = _resolveComponent("el-button");
            const _component_el_dropdown_item = _resolveComponent("el-dropdown-item");
            const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu");
            const _component_el_dropdown = _resolveComponent("el-dropdown");
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("div", _hoisted_3, [
                        _createVNode(_unref(vSelect), {
                            modelValue: metric.value,
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((metric).value = $event)),
                            label: "name",
                            clearable: false,
                            options: metricsOptions.value,
                            "onOption:selected": selectPreset
                        }, {
                            option: _withCtx(({ name }) => [
                                _createTextVNode(_toDisplayString(_ctx.$t(`${name}`)), 1)
                            ]),
                            "selected-option": _withCtx(({ name }) => [
                                _createTextVNode(_toDisplayString(_ctx.$t(`${name}`)), 1)
                            ]),
                            "open-indicator": _withCtx(({ attributes }) => [
                                _createElementVNode("span", _mergeProps(attributes, { class: "arrow-down" }), null, 16)
                            ]),
                            "no-options": _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.$t('campaign.sales-report.no-results')), 1)
                            ]),
                            _: 1
                        }, 8, ["modelValue", "options"])
                    ]),
                    (!_ctx.hasExpandedTable)
                        ? (_openBlock(), _createBlock(HeaderDatepicker, {
                            key: 0,
                            user: user.value,
                            language: user.value?.language,
                            "conversion-window-modal": true,
                            route: "/campaigns/campaign-sales-report",
                            class: "datepicker-table"
                        }, null, 8, ["user", "language"]))
                        : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("div", _hoisted_5, [
                        _createVNode(_component_el_dropdown, null, {
                            dropdown: _withCtx(() => [
                                _createVNode(_component_el_dropdown_menu, null, {
                                    default: _withCtx(() => [
                                        _createVNode(_component_el_dropdown_item, { disabled: "" }, {
                                            default: _withCtx(() => [
                                                _createTextVNode(_toDisplayString(_ctx.$t('dashboard.options')), 1)
                                            ]),
                                            _: 1
                                        }),
                                        _createVNode(_component_el_dropdown_item, { onClick: openEditTableModal }, {
                                            default: _withCtx(() => [
                                                _createTextVNode(_toDisplayString(_ctx.$t('dashboard.edit-columns.title')), 1)
                                            ]),
                                            _: 1
                                        }),
                                        _createVNode(_component_el_dropdown_item, {
                                            disabled: "",
                                            divided: ""
                                        }, {
                                            default: _withCtx(() => [
                                                _createTextVNode(_toDisplayString(_ctx.$t('dashboard.export-data')), 1)
                                            ]),
                                            _: 1
                                        }),
                                        _createVNode(_component_el_dropdown_item, {
                                            id: "csv-menu-item",
                                            onClick: _cache[1] || (_cache[1] = ($event) => (exportSalesReportNew('csv')))
                                        }, {
                                            default: _withCtx(() => [
                                                _createTextVNode(_toDisplayString(_ctx.$t('dashboard.export', { value: '.CSV' })), 1)
                                            ]),
                                            _: 1
                                        }),
                                        _createVNode(_component_el_dropdown_item, {
                                            id: "xls-menu-item",
                                            onClick: _cache[2] || (_cache[2] = ($event) => (exportSalesReportNew('xls')))
                                        }, {
                                            default: _withCtx(() => [
                                                _createTextVNode(_toDisplayString(_ctx.$t('dashboard.export', { value: '.XLS' })), 1)
                                            ]),
                                            _: 1
                                        }),
                                        _createVNode(_component_el_dropdown_item, {
                                            id: "xlsx-menu-item",
                                            onClick: _cache[3] || (_cache[3] = ($event) => (exportSalesReportNew('xlsx')))
                                        }, {
                                            default: _withCtx(() => [
                                                _createTextVNode(_toDisplayString(_ctx.$t('dashboard.export', { value: '.XLSX' })), 1)
                                            ]),
                                            _: 1
                                        })
                                    ]),
                                    _: 1
                                })
                            ]),
                            default: _withCtx(() => [
                                _createVNode(_component_el_button, {
                                    round: "",
                                    "data-test": "dropdown-button"
                                }, {
                                    default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_ctx.$t('dashboard.more-options')) + " ", 1),
                                        _hoisted_6
                                    ]),
                                    _: 1
                                })
                            ]),
                            _: 1
                        }),
                        (_ctx.hasExpandedTable)
                            ? (_openBlock(), _createElementBlock("button", {
                                key: 0,
                                ref: "button",
                                class: "btn export",
                                onClick: _cache[4] || (_cache[4] = ($event) => (setIsTableExpanded(true)))
                            }, _toDisplayString(_ctx.$t('dashboard.expand-table')), 513))
                            : _createCommentVNode("", true)
                    ])
                ])
            ]));
        };
    }
});
